import { Component, OnInit } from "@angular/core"
import { TooltipService } from "app/shared/services/tooltip.service"

@Component({
    selector: "app-tooltip-container",
    templateUrl: "./tooltip-container.component.html",
    standalone: false
})
export class TooltipContainerComponent {
  constructor(public tooltipService: TooltipService) {}
}
